import { useQuery } from '@tanstack/react-query';
import { IResourcePlannerModelResult } from '@legacy/apis/types/resourcePlannerAPI';
import { getFetch } from '@legacy/utils/fetcher';

const RESOURCE_VIEW_OPTIONS_URL_PATH = '/api/v2/resource-planner/view-options';

export const RESOURCE_VIEW_OPTIONS_MSW_STATUS_KEY = 'GetResourceViewOptionsAPI';

export const RESOURCE_VIEW_OPTIONS_KEY = 'RESOURCE_VIEW_OPTIONS';

export interface IMappedViewOptions {
  name: string;
  value: string | undefined;
  options: Array<{
    label: string;
    value: string;
  }>;
}

const resourceViewOptionsFetch = (): Promise<IResourcePlannerModelResult> =>
  getFetch({
    path: RESOURCE_VIEW_OPTIONS_URL_PATH,
    key: RESOURCE_VIEW_OPTIONS_MSW_STATUS_KEY,
  });

export const useGetResourceViewOptions = () => {
  const { data: { model: { entities = [] } = {} } = {}, ...restProps } =
    useQuery({
      queryKey: [RESOURCE_VIEW_OPTIONS_KEY],
      queryFn: resourceViewOptionsFetch,
    });
  return {
    fields: entities.map(
      ({ properties: { name = '', options = [] } = {} }) => ({
        name,
        value: options.find(({ selected }) => selected)?.value,
        options: options.map(({ value }) => ({
          value,
        })),
      }),
    ) as IMappedViewOptions[],
    ...restProps,
  };
};
